import React, { Component, Fragment } from 'react';
import Markdown from 'react-remarkable';
import styled from 'styled-components';
import Navbar from '../shared/Navbar';
import Footer from './Footer';
import Island from '../shared/Island';
import { breakpoints } from '../../constants/styles';
import ScrollToTopOnMount from '../shared/ScrollToTopOnMount';

const StyledPrivacy = styled.div`
  position: relative;
  overflow: hidden;

  ${breakpoints.tabletLandscape} {
    display: none;
  }

  ${breakpoints.desktop} {
    display: block;
  }
`;

const StyledPrivacyContent = styled.div`
  position: relative;
  overflow: hidden;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledPrivacyContainer = styled.div`
  width: 80%;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  padding: 0px 20px 20px 20px;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #022759;
  }

  ${breakpoints.desktop} {
    margin-top: 50px;
    margin-bottom: 50px;
  }
`;

class Privacy extends Component {
  state = {};

  render() {
    return (
      <Fragment>
        <ScrollToTopOnMount />
        <StyledPrivacy>
          <Navbar />
          <StyledPrivacyContent>
            <StyledPrivacyContainer>
              <Markdown>{`
# Aviso de privacidad

El Aviso de Privacidad forma parte del uso del sitio web [www.finauta.com](/#/).

### Responsable

En cumplimiento a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, la sociedad **VINIK Asesores S.A. de C.V.**, (en adelante “**FINAUTA**”) le informa que **FINAUTA** es responsable de la recolección, utilización, almacenamiento, comunicación y protección de sus datos personales. El "**Usuario**" podrá contactar a **FINAUTA** en cualquier momento a través de nuestro correo electrónico hola@finauta.com o directamente en nuestras oficinas ubicadas en Viveros de Coyoacán 109, Viveros de la Loma, Tlalnepantla de Baz, Estado de México, México, CP 54080.

Protegemos y salvaguardamos sus datos personales para evitar el daño, pérdida, destrucción, robo, extravío, alteración, así como el tratamiento no autorizado de sus datos personales.

### Datos personales

La información deberá ser veraz y completa. El **Usuario** responderá en todo momento por los datos proporcionados y en ningún caso **FINAUTA** será responsable de la veracidad de los mismos.

Los datos personales recabados potencialmente al “**Usuario**” son: nombre(s), apellido(s), fecha de nacimiento, edad, sexo, registro federal de contribuyentes, correo electrónico, teléfono fijo, teléfono celular, domicilio, estado, municipio, código postal, calle, número exterior e interior, colonia, país, entre calle, y calle, referencia y fachada, ingreso mensual, vigencia de crédito hipotecario bancario y vigencia de crédito automotriz bancario, monto de deuda(s), metas financieras (montos y fechas).

Sus datos personales serán tratados con base en los principios de licitud, consentimiento, información, calidad, finalidad, lealtad, proporcionalidad y responsabilidad en términos de la Legislación.

Se mantendrá la confidencialidad de sus datos personales estableciendo y manteniendo de forma efectiva las medidas de seguridad administrativas, técnicas y físicas, para evitar su daño, pérdida, alteración, destrucción, uso, acceso o divulgación indebida.

### Qué son los cookies y cómo se utilizan

Los cookies son pequeñas piezas de información que son enviadas por el sitio web a su navegador y se almacenan en el disco duro de su equipo y se utilizan para determinar sus preferencias cuando se conecta a los servicios de nuestros sitios, así como para rastrear determinados comportamientos o actividades llevadas a cabo por usted dentro de nuestros sitios.

En algunas secciones de nuestro sitio requerimos que el cliente tenga habilitados los cookies ya que algunas de las funcionalidades requieren de éstas para trabajar.

Los cookies nos permiten: a) reconocerlo al momento de entrar a nuestros sitios y ofrecerle de una experiencia personalizada, b) conocer la configuración personal del sitio especificada por usted, por ejemplo, los cookies nos permiten detectar el ancho de banda que usted ha seleccionado al momento de ingresar al home page de nuestros sitios, de tal forma que sabemos qué tipo de información es aconsejable descargar, c) calcular el tamaño de nuestra audiencia y medir algunos parámetros de tráfico, pues cada navegador que obtiene acceso a nuestros sitios adquiere un cookie que se usa para determinar la frecuencia de uso y las secciones de los sitios visitadas, reflejando así sus hábitos y preferencias, información que nos es útil para mejorar el contenido, los titulares y las promociones para los usuarios. Los cookies también nos ayudan a rastrear algunas actividades, por ejemplo, en algunas de las encuestas que lanzamos en línea, podemos utilizar cookies para detectar si el usuario ya ha llenado la encuesta y evitar desplegarla nuevamente, en caso de que lo haya hecho. Las cookies le permitirán tomar ventaja de las características más benéficas que le ofrecemos, por lo que le recomendamos que las deje activadas.

El uso de cookies no será utilizado para identificar a los usuarios, con excepción de los casos en que se investiguen posibles actividades fraudulentas.

La sociedad **VINIK Asesores S.A. de C.V.**, titular del portal [www.finauta.com](/#/) almacena automáticamente los datos del **Usuario**, por ejemplo, cuando se registra en el portal o cuando contacta a la sociedad ya sea personalmente o respondiendo a preguntas por correo, fax, a través del portal o por teléfono. 

### Uso de la información

Se utilizará la información para la prestación del servicio de asesoría, comparación, simulación y cálculo de cotizaciones de productos financieros y de inmuebles, así como para el enlace con instituciones bancarias o entidades financieras generales, aseguradoras, brokers hipotecarios y/o inmobiliarios, desarrolladores inmobiliarios y entidades de investigación crediticia.

De igual manera estos datos son utilizados para procurar un servicio eficiente, informarle sobre cambios o nuevos servicios que estén relacionados con el producto o servicio solicitado, dar cumplimiento a obligaciones contraídas con sus usuarios y/o evaluar la calidad de nuestro servicio.

### Limitación de uso y divulgación de información

En nuestro programa de notificación de promociones, newsletter, blog, ofertas y servicios a través de correo electrónico, sólo **FINAUTA** tiene acceso a la información recabada. Este tipo de publicidad se realiza mediante avisos y mensajes promocionales de correo electrónico, los cuales sólo serán enviados a usted y a aquellos contactos registrados para tal propósito, esta indicación podrá usted modificarla en cualquier momento enviando un correo a hola@finauta.com. En los correos electrónicos enviados, pueden incluirse ocasionalmente ofertas de terceras partes que sean nuestros socios comerciales.

### Derechos ARCO (acceso, rectificación, cancelación y oposición)

En cumplimiento de lo dispuesto por los artículos 15, 16, 17, 18 y 19 de la Ley Federal de Protección de Datos Personales en Posesión de Particulares, la sociedad **VINIK Asesores S.A. de C.V.**, titular del portal [www.finauta.com](/#/) ha designado al Sr. Javier Sinco Nájera como encargado del Departamento de Servicios y Protección de Datos Personales y quien se ubica en Viveros de Coyoacán 109, Viveros de la Loma, Tlalnepantla de Baz, Estado de México, México, CP 54080 y con teléfono número +52 1 55 2858 2472.

### Para ejercer sus derechos ARCO y revocar el consentimiento otorgado

Como titular de datos personales, el "**Usuario**" podrá ejercitar los derechos ARCO (acceso, cancelación, rectificación y oposición al tratamiento de sus datos personales), o bien, revocar el consentimiento que haya otorgado a **FINAUTA**, para el tratamiento de sus datos personales, enviando directamente su solicitud al Sr. Javier Sinco Nájera, encargado del Departamento de Servicio y Protección de Datos Personales ubicado en Viveros de Coyoacán 109, Viveros de la Loma, Tlalnepantla de Baz, Estado de México, México, CP 54080 y con teléfono número +52 1 55 2858 2472, o bien vía correo electrónico a hola@finauta.com.

Dicha solicitud deberá contener por lo menos: (a) nombre y domicilio u otro medio para comunicarle la respuesta a su solicitud; (b) los documentos que acrediten su identidad o, en su caso, la representación legal; (c) la descripción clara y precisa de los datos personales respecto de los que se solicita ejercer alguno de los derechos ARCO, (d) la manifestación expresa para revocar su consentimiento al tratamiento de sus datos personales y, por tanto, para que no se usen; (d) cualquier otro elemento que facilite la localización de los datos personales.

Su petición deberá ir acompañada de los fundamentos por los que solicita dicha revocación y una identificación oficial del titular de los datos o de su apoderado. En un plazo máximo de 20 (veinte) días hábiles atenderemos su solicitud y le informaremos sobre la procedencia de esta a través del correo electrónico del que provenga la petición.

**FIANUTA** solicita al **Usuario** que actualice sus datos cada vez que éstos sufran alguna modificación, ya que esto permitirá brindarle un servicio eficiente y personalizado.

### Transferencias de información con terceros

**FINAUTA** únicamente realiza remisiones de datos para cumplir con las obligaciones contraídas con los clientes o usuarios.

En ningún momento **FINAUTA** brindará información de los usuarios a autoridades gubernamentales, exceptuando los casos en que sean solicitados por mandamiento judicial o en los que lo señale la ley.

Los datos solicitados son indispensables para que **FINAUTA** le proporcione el servicio solicitado, por lo que de no contar con los mismos la sociedad se encuentra materialmente imposibilitada de cumplir el fin principal de la relación con sus usuarios.

### Protección

**VINIK Asesores S.A. de C.V.**, titular del portal [www.finauta.com](/#/) ha adoptado medidas de seguridad administrativas, técnicas y físicas que permiten proteger los datos personales que sus usuarios proporcionan contra daño, pérdida, alteración, destrucción o su uso, acceso y/o tratamiento no autorizado. Asimismo, nuestro personal está debidamente capacitado para tratar los datos personales en el mayor marco de confidencialidad, privacidad, secrecía y absoluto cumplimiento de la Ley Federal de Protección de Datos Personales en Posesión de Particulares.

Queda expresamente señalado que el servicio de asesoría, comparación, simulación, calculo y cotización de productos financieros y seguros que presta **VINIK Asesores S.A. de C.V.** a través de su portal [www.finauta.com](/#/) lo hace de forma estimada con base en la información publicada por las instituciones financieras y de seguros por lo que se pueden presentar cambios sin previo aviso. **VINIK Asesores S.A. de C.V.** no es responsable de cerciorarse o comprobar la veracidad de la información proporcionada por las diversas instituciones financieras y de seguros, así como por instituciones gubernamentales, ni por el cumplimiento de estas últimas de los ofrecimientos presentados en sus cotizaciones y los resultados que su comparador arroja son para fines meramente ilustrativos.

### Cambios en el aviso de privacidad

Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones al presente aviso de privacidad, para la atención de novedades legislativas o jurisprudenciales, políticas internas, nuevos requerimientos para la prestación u ofrecimiento de nuestros servicios o productos y prácticas del mercado.

Las referidas modificaciones o actualizaciones serán publicadas y puestas a disposición del público a través del portal [www.finauta.com](/#/), sección Aviso de Privacidad o bien, se le hará llegar por medio de correo electrónico a la última dirección electrónica que nos haya proporcionado.

### Aceptación de los términos

Esta declaración de Privacidad está sujeta a los términos y condiciones del sitio web de **FINAUTA** antes descrito, lo cual constituye un acuerdo legal entre el usuario y **FINAUTA**.

Si el **Usuario** utiliza los servicios en el sitio web [www.finauta.com](/#/), significa que ha leído, entendido, acordado y manifestado la voluntad de apegarse a los términos y condiciones expuestos en el aviso de privacidad ([www.finauta.com/#/aviso-de-privacidad](www.finauta.com/#/aviso-de-privacidad)) y en el aviso legal ([www.finauta.com/#/aviso-legal](www.finauta.com/#/aviso-legal).

### Autoridad

Si el **Usuario** considera que han sido vulnerados sus derechos respecto de la protección de datos personales, tiene el derecho de acudir a la autoridad correspondiente para defender su ejercicio. La autoridad es el Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI), su sitio web es: [www.ifai.org.mx](www.ifai.org.mx).

### Fecha de la última actualización

Estimado usuario, se le notifica que el Aviso de Privacidad ha sido modificado el día **11 de enero de 2019**.

El **Usuario** podrá siempre almacenar y/o imprimir este Aviso de Privacidad.
`}</Markdown>
            </StyledPrivacyContainer>
          </StyledPrivacyContent>
          <Footer />
        </StyledPrivacy>
      </Fragment>
    );
  }
}

export default Privacy;
